import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import _ from 'lodash';
import { receivedBrandAwarenessData, receivedAdAwarenessData, receivedBrandConsiderationData, receivedBrandData, didRequestInitialData, initTelescopeData, receivedTelescopeData, setEndDate, setStartDate, setAvailableDates} from '../actions/dataAction';
import GridView from './GridView.js';
import IndexView from './dataViews/IndexView';
import ScoreView from './dataViews/ScoreView';
import RelevanceView from './dataViews/RelevanceView';
import SummaryView from './dataViews/detailViews/SummaryView';
import PerceptionView from './dataViews/detailViews/PerceptionView';
import PriceIndexView from './dataViews/detailViews/PriceIndexView';
import ListView from './dataViews/detailViews/ListView';
import WordCloudView from './dataViews/detailViews/WordCloudView';
import PieChartView from './dataViews/detailViews/PieChartView';
import DoughnutChartView from './dataViews/detailViews/DoughnutChartView';
import BarChartView from './dataViews/detailViews/BarChartView';
import LineChartView from './dataViews/detailViews/LineChartView';
import KeyAttributes from './dataViews/detailViews/KeyAttributes';
import KeyDrivers from './dataViews/detailViews/KeyDrivers';
import RowComponent from './dataViews/detailViews/RowComponent';
import TagBox from './dataViews/detailViews/TagBox';
import SentimentReport from './dataViews/detailViews/SentimentReport';
import Suggestions from './dataViews/detailViews/Suggestions';
import Solutions from './dataViews/detailViews/Solutions';
import PortfolioMatrix from './dataViews/detailViews/PortfolioMatrix';
import RelevancePerformanceView from './dataViews/detailViews/RelevancePerformance';
import BrandHealthMenu from './dataViews/BrandHealthMenu';
import BrandRelevancePosition from './dataViews/detailViews/BrandRelevancePosition';
import KeyFocusImprovements from './dataViews/detailViews/KeyFocusImprovements';
import KeyFocusIndustry from './dataViews/detailViews/KeyFocusIndustry';
import KPIPyramid from './dataViews/detailViews/KPIPyramid';
import TooltipButton from './dataViews/detailViews/TooltipButton';
import Launcher from './dataViews/insights/Launcher';
import {Box, CTAButton} from './StyledComponents';


class ViewController extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  prepareVariableData(inData) {
    let outData = {};

    if (!inData || !inData.variables) {
        return {};
    }

    inData.variables.forEach(function(obj,i) {
        outData[obj.id] = obj;
    });

    return outData;
  }

  getDataPoint(dataPoint, numberOfDataPoints) {
    const rawData = this.props.user.client && this.props.user.client.rawData;
    const endDate = this.props.data && this.props.data.endDate;
    let values = [];
    let labels = [];
    let chosenDate = null;

    if (!rawData) {
      return null;
    }
    const dataArray = _.filter(rawData, function(row, i) {
      return row[0].value === dataPoint;
    })

    let data;

    if (numberOfDataPoints) {
      data = dataArray;
    } else {
      data = dataArray[0];
    }

    switch(dataPoint) {
      case 'valueTotalSales':
        data = null;
        _.each(dataArray, function(obj, i) {
          let objDate = obj[1].value;
          if (moment(objDate).isBefore(endDate) && (!data || moment(objDate).isAfter(chosenDate))) {
            chosenDate = objDate;
            data = dataArray[i];
          }
        });

        // Enter as percentage
        values = _.map(data, function(dp, i) {
          return dp.value && parseFloat(dp.value).toFixed(0);
        })
        return {
          "type": "chart",
          "title": "Value total sales",
          "description": "",
          "unit": "percentage",
          "values": [
            {
              "name": "3 Butik",
              "value": values[2]
            },
            {
              "name": "3 Telesales",
              "value": values[3]
            },
            {
              "name": "Customer Service",
              "value": values[4]
            },
            {
              "name": "Online Sales",
              "value": values[5]
            },
            {
              "name": "Other",
              "value": values[6]
            },
            {
              "name": "Retail",
              "value": values[7]
            }
          ]
        };
        break;
      case 'mostProfitableChannel':
        data = null;
        _.each(dataArray, function(obj, i) {
          let objDate = obj[1].value;
          if (moment(objDate).isBefore(endDate) && (!data || moment(objDate).isAfter(chosenDate))) {
            chosenDate = objDate;
            data = dataArray[i];
          }
        });
        values = _.map(data, function(dp, i) {
          return dp.value && parseFloat(dp.value).toFixed(0);
        })
        return {
          "type": "chart",
          "title": "Most profitable channel",
          "description": "",
          "unit": "percentage",
          "values": [
            {
              "name": "3 Butik",
              "value": values[2]
            },
            {
              "name": "3 Telesales",
              "value": values[3]
            },
            {
              "name": "Customer Service",
              "value": values[4]
            },
            {
              "name": "Online Sales",
              "value": values[5]
            },
            {
              "name": "Other",
              "value": values[6]
            },
            {
              "name": "Retail",
              "value": values[7]
            }
          ]
        };
        break;
      case 'totalMargin':
        data = null;
        _.each(dataArray, function(obj, i) {
          let objDate = obj[1].value;
          if (moment(objDate).isBefore(endDate) && (!data || moment(objDate).isAfter(chosenDate))) {
            chosenDate = objDate;
            data = dataArray[i];
          }
        });
        values = _.map(data, function(dp, i) {
          return dp.value && parseFloat(dp.value).toFixed(0);
        })
        return {
          "type": "chart",
          "title": "Total margin",
          "description": "",
          "unit": "percentage",
          "values": [
            {
              "name": "3 Butik",
              "value": values[2]
            },
            {
              "name": "3 Telesales",
              "value": values[3]
            },
            {
              "name": "Customer Service",
              "value": values[4]
            },
            {
              "name": "Online Sales",
              "value": values[5]
            },
            {
              "name": "Other",
              "value": values[6]
            },
            {
              "name": "Retail",
              "value": values[7]
            }
          ]
        };
        break;
      case 'priceIndex':
        if (!data || !data.length) {
          return null;
        }

        data = data.slice(2);

        values = _.map(data, function(dp, i) {
          if (!dp.value) {
            return false;
          }

          let v = dp.value.replace(",", ".");
          return parseInt(v * 100, 10);
        });
        return {
            "type": "priceIndex",
            "title": "Price index",
            "value": values[0],
            "competitors": [
              {
                "name": "Telia",
                "value": values[1]
              },
              {
                "name": "Tele2",
                "value": values[2]
              },
              {
                "name": "Telenor",
                "value": values[3]
              },
              {
                "name": "Comviq",
                "value": values[4]
              },
              {
                "name": "Hallon",
                "value": values[5]
              },
              {
                "name": "Halebop",
                "value": values[6]
              },
              {
                "name": "Vimla",
                "value": values[7]
              }
            ]
          };
        break;
        case 'serviceReaction':
          values = _.map(data, function(dp, i) {
            return dp.value && parseFloat(dp.value).toFixed(0);
          })
          return {
            "type": "chart",
            "title": "Service Reaction",
            "description": "",
            "unit": "percentage",
            "values": [
              {
                "name": "3 Butikerna",
                "value": values[2]
              },
              {
                "name": "3 Telesales",
                "value": values[3]
              },
              {
                "name": "Customer Service",
                "value": values[4]
              },
              {
                "name": "Online Sales",
                "value": values[5]
              },
              {
                "name": "Retail",
                "value": values[7]
              }
            ]
          };
          break;
        case 'adAwarenessLiking':
          values = _.map(data, function(dp, i) {
            return dp.value && parseFloat(dp.value).toFixed(0);
          })
          return {
            "type": "chart",
            "title": "Drop-off from ad awareness to liking",
            "description": "",
            "unit": "percentage",
            "values": [
              {
                "name": "3",
                "value": values[2]
              },
              {
                "name": "Halebop",
                "value": values[3]
              },
              {
                "name": "Tele2",
                "value": values[4]
              },
              {
                "name": "Comviq",
                "value": values[5]
              },
              {
                "name": "Telenor",
                "value": values[6]
              },
              {
                "name": "Telia",
                "value": values[7]
              },
              {
                "name": "Hallon",
                "value": values[8]
              },
              {
                "name": "Vimla",
                "value": values[7]
              }
            ]
          };
          break;
        case 'nps':
          labels = ["SUM OF NPS",	"SUM OF NPS SVAR", "Sum OF PROM",	"SUM OF DETRACTORS"];

          return {
            title: "Net Promoter Score",
            data: data,
            labels: labels
          }

          break;
        case 'productChurn':
          labels = ["TÄCKNING",	"HAR INGET BEHOV AV PRODUKTEN"];
          data = _.orderBy(data, function(e) { return e[1].value }, ['asc']);

          return {
            title: "Product Churn",
            data: data,
            labels: labels
          }
          break;
        case 'proposalChurn':
          labels = ["FICK BÄTTRE ERBJUDANDE HOS ANNAN OPERATÖR","ÄR MISSNÖJD MED 3"];
          data = _.orderBy(data, function(e) { return e[1].value }, ['asc']);

          return {
            title: "Change",
            data: data,
            labels: labels
          }
          break;
        default:
          break;
    }

  }

  views(view, data) {
    const digitalFootprint = this.props.user && this.props.user.client && this.props.user.client.digitalFootprint;

    const priceData = data.price || {};
    const priceComponents = priceData.components || {};
    const productData = data.product || {};
    const productComponents = productData.components || {};
    const promotionData = data.promotion || {};
    const promotionComponents = promotionData.components || {};
    const proposalData = data.proposal || {};
    const proposalComponents = proposalData.components || {};
    const preferenceData = data.preference || {};
    const preferenceComponents = preferenceData.components || {};
    const peopleData = data.people || {};
    const peopleComponents = peopleData.components || {};
    const placeData = data.place || null;

    const suggestionsDummyData = {
      "title": "solutions",
      "observation": {
        "property": "perception",
      },
      "suggestions": {
        "property": [
          "proposal"
        ]
      }
    }

    const tagboxDummyData = {
      "title": "How?",
      "colored": true,
      "tags": [
        "feedback",
        "market possibilities",
        "main message",
        "channels"
      ],
    }

    const reportPerceptionDummyData = [
      {
        "observation": {
          "property": "neutral",
          "level": "high",
        },
        "outtake": {
          "property": "price",
          "level": "low"
        }
      },
      {
        "observation": {
          "property": "unaware",
          "level": "high",
        },
        "outtake": {
          "property": "positive",
          "level": "low"
        }
      }
    ];

    const reportListDummyData = [
      "pris",
      "billig",
      "bästa pris"
    ];

    const brandData = (this.props.data && this.props.data.variableData && this.props.data.variableData.brand) || {};
    const brandAwarenessPieChartData = {
      "type": "chart",
      "title": "Brand awareness",
      "description": "",
      "unit": "percentage",
      "values": [
        {
          "name": "No",
          "value": (brandData.awareness && brandData.awareness.no) || 0
        },
        {
          "name": "Yes",
          "value": (brandData.awareness && brandData.awareness.yes) || 0
        }
      ]
    };

    const brandConsiderationData = {
      "type": "chart",
      "title": "Consideration",
      "description": "",
      "unit": "percentage",
      "values": [
        {
          "name": "No",
          "value": (brandData.consideration && brandData.consideration.no) || 0
        },
        {
          "name": "Yes",
          "value": (brandData.consideration && brandData.consideration.yes) || 0
        },
      ]
    };

    const sov = brandData.sov;
    const sovItems = [];
    for (var brand in sov) {
      if (sov.hasOwnProperty(brand)) {
        sovItems.push({name: brand[0].toUpperCase() + brand.substring(1), value: parseInt(sov[brand], 10)});
      }
    }

    const shareOfVoiceData = {
      "title": "Share of voice digital footprint",
      "description": "",
      "unit": "percentage",
      "values": sovItems
    }

    const channels = this.props.data && this.props.data.telescope && this.props.data.telescope._data && this.props.data.telescope._data.prm && this.props.data.telescope._data.prm.channels;
    const channelItems = [];
    let total = 0;
    for (var channel in channels) {
      if (channels.hasOwnProperty(channel)) {
        total = parseInt(total, 10) + parseInt(channels[channel], 10);
      }
    }
    for (var channel in channels) {
      if (channels.hasOwnProperty(channel)) {
        let channelName = channel;

        switch (channelName) {
          case 'social_reviews':
           channelName = 'Reviews';
           break;
         case 'social_blogs':
          channelName = 'Blogs';
          break;
        case 'social_comments':
           channelName = 'Social comments';
           break;
        case 'social_message_boards':
          channelName = 'Forums';
          break;
        }

        channelItems.push({name:channelName, value: parseInt(parseInt(channels[channel], 10) / parseInt(total, 10) * 100, 10)})
      }
    }

    const channelsData = {
      "title": "Most active channels on social media",
      "description": "",
      "unit": "percentage",
      "values": channelItems
    }

    const womData = (this.props.data && this.props.data.telescope && this.props.data.telescope._data.prm && this.props.data.telescope._data.prm.wom_exposure) || {};

    const womExposureData = {
      "type": "chart",
      "title": "WOM Exposure",
      "description": "Have you talked about the brand to friends or family?",
      "unit": "percentage",
      "values": [
        {
          "name": "Yes",
          "value": womData.yes
        },
        {
          "name": "No",
          "value": womData.no
        }
      ]
    }

    const adAwarenessTime = this.props.data && this.props.data.adAwarenessData;
    let adAwarenessTimeData = [];
    _.each(adAwarenessTime, function(o,i) {

        adAwarenessTimeData.push([
          {type:"dummy", value:"dummy"},
          {type:"date", value:o.date},
          {type:"value", value:o && o.value && o.value.yes},
        ])
    });
    const adAwarenessData = {
      title: "Ad awareness",
      data: adAwarenessTimeData,
      labels: ["Yes"]
    }

    const brandAwarenessTime = this.props.data && this.props.data.brandAwarenessData;
    const brandConsiderationTime = this.props.data && this.props.data.brandConsiderationData;

    let brandAwarenessTimeData = [];
    _.each(brandAwarenessTime, function(o,i) {
      let dp = [
          {type:"dummy", value:"dummy"},
          {type:"date", value:o.date},
          {type:"value", value:o && o.value && parseFloat(o.value.yes).toFixed(2)}
      ]

      if (brandConsiderationTime && brandConsiderationTime[i]) {
        dp.push({type:"value", value: brandConsiderationTime[i].value && parseFloat(brandConsiderationTime[i].value.yes).toFixed(2)});
      }
      brandAwarenessTimeData.push(dp);
    });

    const brandAwarenessConsiderationData = {
      title: "Change",
      data: brandAwarenessTimeData,
      labels: ["Brand awareness (%)", "Brand consideration (%)"]
    }

    const sovData = this.props.data && this.props.data.sovData;
    let sovTimeData = [];
    let labels = [];

    _.each(sovData, function(o,i) {
      labels = [];

      let dp = [
          {type:"dummy", value:"dummy"},
          {type:"date", value:o.date},
      ]

      _.each(o.value, function(val, j) {
        dp.push({type:"value", value: parseFloat(val.value).toFixed(1)});
        labels.push((val.brand).toUpperCase())
      })
      sovTimeData.push(dp);

    });

    const shareOfVoiceTimeData = {
      title: "Share of voice - over time",
      data: sovTimeData,
      labels: labels
    }

    // MANUAL WORDCLOUD DATA
    const useWashedSentimentData = this.props.user && this.props.user.client && this.props.user.client.settings && this.props.user.client.settings.useWashedSentimentDataForWordclouds;

    const wordCloudData = (this.props.user && this.props.user.client && this.props.user.client.wordCloudSettings) || [];

    function washedWordCloudData(param) {
      let words = [];
      let paramSentiment = _.filter(wordCloudData, function(row, i) {
        return row[0] && row[0].value === param;
      })

      paramSentiment.length && _.each(paramSentiment, function(col, i) {
        words.push({word: col[1].value, freq: parseFloat(col[2].value)});
      });

      return {type: "word cloud", title:"", words: words};
    }

    const likabilityData = {
      "type": "chart",
      "title": "Likability",

    };

    const mentionsPrice = {
      title: "Mentions regarding price - over time",
      data: null
    }

    const dashboard = [
      {components:[<IndexView key="index"/>]},
      {components:[<ScoreView key="score" contentHeight/>, this.props.data.relevanceChartActive ? <RelevanceView key="relevance" /> : <KPIPyramid key="KPIPyramid"/>]}
    ];

    const insights = [
      {components:[<KeyAttributes key="keyAttributes" propData={data}/>]},
      {components:[<KeyDrivers key="keyDrivers" printBreak={true} propData={data} contentHeight/>, <RowComponent children={[<Box className="col-md-6 noBottomMargin marginRight"><Solutions/></Box>,<Box className="col-md-6 noBottomMargin marginLeft"><SentimentReport data={null} /></Box>]}/> ]}
    ];

    const portfolio = [
      {components:[<PortfolioMatrix data={priceComponents.perception} dataReport={reportPerceptionDummyData} key="portfolioMatrix"/>]},
      {components:[<RelevancePerformanceView key="priceIndex" printBreak={true} data={priceComponents.priceIndex}/>]},
    ];

    const insightsPrice = [
      {components:[<SummaryView data={priceData} key="summary"/>,<PerceptionView data={priceComponents.perception} dataReport={reportPerceptionDummyData} reportMode={true} key="perception"/>]},
      {components:[<PriceIndexView key="priceIndex" printBreak={true} data={priceComponents.priceIndex}/>]},
      {components:[<Box><Suggestions data={suggestionsDummyData} /><TagBox data={tagboxDummyData} /></Box>, <ListView tableRows={5} key="list" data={priceComponents.sentimentTable} dataReport={reportListDummyData} reportMode={true} title="Sentiment (top 5)"/>]}
    ];

    const price = [
      {components:[<SummaryView data={priceData} key="summary" contentHeight/>,<PerceptionView data={priceComponents.perception} reportMode={false} key="perception" id="price.perception"/>]},
      {components:[<PriceIndexView key="priceIndex" printBreak={true} data={this.getDataPoint("priceIndex")} id="priceIndex"/>]},
      {components:[<WordCloudView data={useWashedSentimentData ? washedWordCloudData("price") : priceComponents.sentimentWordCloud} key="wordCloud" title="Which attributes do you get associated with" />]}
    ];

    const priceDigitalFootprint = [
      {components:[<SummaryView data={priceData} key="summary" contentHeight/>,<PerceptionView data={priceComponents.perception} reportMode={false} key="perception" id="price.perception"/>]},
      {components:[<LineChartView printBreak={true} data={mentionsPrice} title="Mentions regarding price - over time" key="brandawareness" id="brandAwarenessConsiderationChange" contentHeight/>, <Box key="solutions"><Solutions parameter="price"/></Box>]},
      {components:[<WordCloudView data={useWashedSentimentData ? washedWordCloudData("price") : priceComponents.sentimentWordCloud} key="wordCloud" title="Which attributes do you get associated with" />]}
    ];

    const product = [
      {components:[<SummaryView data={productData} key="summary" contentHeight/>,<PerceptionView data={productComponents.perception} description="How your products are viewed on the market" key="perception"/>]},
      {components:[<LineChartView printBreak={true} data={this.getDataPoint("productChurn", 6)} key="productChurnLineChart" id="productChurn"/>]},
      {components:[<WordCloudView data={useWashedSentimentData ? washedWordCloudData("product") : (productComponents.productAssociationWordCloud || productComponents.sentimentWordCloud)} key="wordCloud" title="What's said about your product" />]}
    ];

    const productDigitalFootprint = [
      {components:[<SummaryView data={productData} key="summary" contentHeight/>,<PerceptionView data={productComponents.perception} description="How your products are viewed on the market" key="perception"/>]},
      {components:[<LineChartView printBreak={true} data={mentionsPrice} title="Mentions regarding price - over time" key="brandawareness" id="brandAwarenessConsiderationChange" contentHeight/>, <Box key="solutions"><Solutions parameter="product"/></Box>]},
      {components:[<KeyDrivers key="keyDrivers" printBreak={true} propData={null} title="Which attributes do you get associated with?"/>, <WordCloudView data={useWashedSentimentData ? washedWordCloudData("product") : (productComponents.productAssociationWordCloud || productComponents.sentimentWordCloud)} key="wordCloud" title="What's said about your product" />]}
    ];

    const place = [
      {components:[<SummaryView data={placeData || {name:'Place'}} key="summary" contentHeight/>,<PerceptionView key="perception"/>]},
      {components:[<PieChartView printBreak={true} data={this.getDataPoint("valueTotalSales")} key="ValueTotalSalesPie" id="valueTotalSales" pt1/>, <BarChartView printBreak={true} data={this.getDataPoint("mostProfitableChannel")} key="mostProfitableChannelBarChart" id="mostProfitableChannel" pt1/>]},
      {components:[<PieChartView printBreak={true} data={this.getDataPoint("totalMargin")} key="TotalMarginPie" id="totalMargin" pt1/>, <WordCloudView key="wordCloud" data={useWashedSentimentData ? washedWordCloudData("place") : null} title="Place association"/>]}
    ];

    const placeDigitalFootprint = [
      {components:[<SummaryView data={placeData || {name:'Place'}} key="summary" contentHeight/>,<PerceptionView key="perception"/>]},
      {components:[<LineChartView printBreak={true} data={mentionsPrice} title="Mentions regarding price - over time" key="brandawareness" id="brandAwarenessConsiderationChange" contentHeight/>, <Box key="solutions"><Solutions parameter="product"/></Box>]},
      {components:[<PieChartView printBreak={true} data={this.getDataPoint("totalMargin")} key="TotalMarginPie" id="totalMargin" pt1/>, <WordCloudView key="wordCloud" data={useWashedSentimentData ? washedWordCloudData("place") : null} title="Place association"/>]}
    ];

    const promotion = [
      {components:[<SummaryView data={promotionData} key="summary" contentHeight/>,<PerceptionView data={promotionComponents.perception} key="perception"/>]},
      {components:[<LineChartView printBreak={true} data={adAwarenessData} title="Ad awareness" key="adawareness" id="adAwareness"/>, <BarChartView printBreak={true} data={this.getDataPoint("adAwarenessLiking")} key="adAwarenessLiking" id="adAwarenessLiking"/>]},
      {components:[<DoughnutChartView data={channelsData} key="doughnut"  title="Most active channels on SOCIAL MEDIA" id="mostActiveChannels"/>, <WordCloudView data={useWashedSentimentData ? washedWordCloudData("promotion") : (promotionComponents.brandAssociation || promotionComponents.sentimentWordCloud)} key="wordCloud" title="TRENDING THEMES IN YOUR INDUSTRY"/>]}
    ];

    const promotionDigitalFootprint = [
      {components:[<SummaryView data={promotionData} key="summary" contentHeight/>,<PerceptionView data={promotionComponents.perception} key="perception"/>]},
      {components:[<LineChartView printBreak={true} data={adAwarenessData} title="Ad awareness" key="adawareness" id="adAwareness"/>, <Box key="solutions"><Solutions parameter="product"/></Box>]},
      {components:[<DoughnutChartView data={channelsData} key="doughnut"  title="Most active channels on SOCIAL MEDIA" id="mostActiveChannels"/>, <WordCloudView data={useWashedSentimentData ? washedWordCloudData("promotion") : (promotionComponents.brandAssociation || promotionComponents.sentimentWordCloud)} key="wordCloud" title="TRENDING THEMES IN YOUR INDUSTRY"/>]}
    ];

    const proposal = [
      {components:[<SummaryView data={proposalData} key="summary" contentHeight/>,<PerceptionView data={proposalComponents.perception} key="perception"/>]},
      {components:[<LineChartView printBreak={true} data={this.getDataPoint("proposalChurn", 6)} key="proposalChurn" id="proposalChurn"/>]},
      {components:[<WordCloudView data={useWashedSentimentData ? washedWordCloudData("proposal") : (proposalComponents.proposalAssociation || proposalComponents.sentimentWordCloud)} key="wordCloud" title="Attributes you get associated with"/>]}
    ];

    const proposalDigitalFootprint = [
      {components:[<SummaryView data={proposalData} key="summary" contentHeight/>,<PerceptionView data={proposalComponents.perception} key="perception"/>]},
      {components:[<LineChartView printBreak={true} data={mentionsPrice} title="Mentions regarding price - over time" key="brandawareness" id="brandAwarenessConsiderationChange" contentHeight/>, <Box key="solutions"><Solutions parameter="product"/></Box>]},
      {components:[<WordCloudView data={useWashedSentimentData ? washedWordCloudData("proposal") : (proposalComponents.proposalAssociation || proposalComponents.sentimentWordCloud)} key="wordCloud" title="Attributes you get associated with"/>]}
    ];

    const people = [
      {components:[<SummaryView data={peopleData} key="summary" contentHeight/>,<PerceptionView data={peopleComponents.perception} key="perception"/>]},
      {components:[<BarChartView printBreak={true} data={this.getDataPoint("serviceReaction")} key="serviceReactionBarChart" id="serviceReaction"/>, <LineChartView printBreak={true} data={this.getDataPoint("nps", 6)} key="npsLineChart" id="nps"/>]},
      {components:[<WordCloudView data={useWashedSentimentData ? washedWordCloudData("people") : peopleComponents.sentimentWordCloud} key="wordCloud" title="Trending themes in your industry"/>]}
    ];

    const peopleDigitalFootprint = [
      {components:[<SummaryView data={peopleData} key="summary" contentHeight/>,<PerceptionView data={peopleComponents.perception} key="perception"/>]},
      {components:[<LineChartView printBreak={true} data={mentionsPrice} title="Mentions regarding price - over time" key="brandawareness" id="brandAwarenessConsiderationChange" contentHeight/>, <Box key="solutions"><Solutions parameter="product"/></Box>]},
      {components:[<WordCloudView data={useWashedSentimentData ? washedWordCloudData("people") : peopleComponents.sentimentWordCloud} key="wordCloud" title="Trending themes in your industry"/>]}
    ];

    const preference = [
      {components:[<SummaryView data={preferenceData} key="summary" contentHeight/>,<PerceptionView data={preferenceComponents.perception} key="perception"/>]},
      {components:[<PieChartView printBreak={true} data={brandConsiderationData} key="ConsiderationPie" id="consideration" paddingTop contentHeight />, <PieChartView printBreak={true} data={womExposureData} key="womExposure" id="womExposure" paddingTop /> /* <ListView tableRows={10} data={preferenceComponents.brandAttributes} key="list" title="Brand attributes"/>*/]},
      {components:[<WordCloudView data={useWashedSentimentData ? washedWordCloudData("preference") : preferenceComponents.sentimentWordCloud} key="wordCloud" title="Trending themes in your industry"/>]}
    ];

    const preferenceDigitalFootprint = [
      {components:[<SummaryView data={preferenceData} key="summary" contentHeight/>,<PerceptionView data={preferenceComponents.perception} key="perception"/>]},
      {components:[<LineChartView printBreak={true} data={mentionsPrice} title="Mentions regarding price - over time" key="brandawareness" id="brandAwarenessConsiderationChange" contentHeight/>, <Box key="solutions"><Solutions parameter="product"/></Box>]},
      {components:[<WordCloudView data={useWashedSentimentData ? washedWordCloudData("preference") : preferenceComponents.sentimentWordCloud} key="wordCloud" title="Trending themes in your industry"/>]}
    ];

    const brandHealth = [
      {components:[<BrandHealthMenu title="Brand Health" key="brandhealth" contentHeight/>, <BrandRelevancePosition key="BrandRelevancePosition" printBreak={true} id="brandRelevancePosition"/>]},
      {components:[<RowComponent noFlex children={[<PieChartView printBreak={true} data={brandAwarenessPieChartData} id="brandAwareness" key="BrandAwarenessPie" title="Brand awareness" legendBottom marginRight/>, <PieChartView printBreak={true} data={brandConsiderationData} id="consideration" key="ConsiderationPie" marginLeft mr0 mb2 legendBottom/>]} />, <LineChartView printBreak={true} data={brandAwarenessConsiderationData} title="Change" key="brandawareness" id="brandAwarenessConsiderationChange" contentHeight/>]},
      {components:[<DoughnutChartView data={shareOfVoiceData} key="doughnut"  title="Share of voice - digital footprint" id="shareOfVoice"/>, <PieChartView printBreak={true} data={null} key="MarketSharePie" title="Market Share"/>, <TooltipButton path="/recommendations" label="Telescope it" tooltip="DO YOU WANT TO KNOW HOW TO IMPROVE YOUR BRAND STATUS" />]}
    ];

    const brandUniverse = [
      {components:[<BrandHealthMenu title="Brand Universe" subTitle="Digital footprint" key="brandhealth" contentHeight/>, <BrandRelevancePosition key="BrandRelevancePosition" printBreak={true} id="brandRelevancePosition"/>]},
      {components:[<LineChartView printBreak={true} data={shareOfVoiceTimeData} title="Share of voice - over time" key="brandawareness" id="brandAwarenessConsiderationChange" contentHeight/>, <PieChartView printBreak={true} data={likabilityData} id="brandAwareness" key="BrandAwarenessPie" title="Likability" legendBottom />]},
      {components:[<KeyFocusIndustry />, <Box key="solutions"><Solutions title="You should take action within these areas" primaryText="To improve the brand status you are recommended to work within the area of:" secondaryText="And following focus area:"/></Box>, <TooltipButton path="/recommendations" label="Telescope it" tooltip="DO YOU WANT TO KNOW HOW TO IMPROVE YOUR BRAND STATUS" />]}
    ];

    const recommendations = [
      {components:[<BrandHealthMenu title="Recommendations" key="BrandHealthMenu" contentHeight/>, <KeyAttributes key="keyAttributes" propData={data}/>]},
      {components:[<KeyDrivers key="keyDrivers" printBreak={true} propData={data}/>, <Box key="solutions"><Solutions/></Box>, <TooltipButton key="dashboardBtn" path="/dashboard" label="Explore it" tooltip="SIMULATE YOUR FUTURE" />]},
      {components:[<KeyFocusImprovements />, <CTAButton invisible
        className="hidden-xs"
      >
        <span>&nbsp;</span>
      </CTAButton>]},
    ];

    const views = {
      portfolio: portfolio,
      dashboard: dashboard,
      insights: insights,
      insightsPrice: insightsPrice,
      price: digitalFootprint ? priceDigitalFootprint : price,
      product: digitalFootprint ? productDigitalFootprint : product,
      place: digitalFootprint ? placeDigitalFootprint : place,
      promotion: digitalFootprint ? promotionDigitalFootprint : promotion,
      proposal: digitalFootprint ? proposalDigitalFootprint : proposal,
      people: digitalFootprint ? peopleDigitalFootprint : people,
      preference: digitalFootprint ? preferenceDigitalFootprint : preference,
      brandHealth: brandHealth,
      brandUniverse: brandUniverse,
      recommendations: recommendations
    }
    return views[view];
  }

  route(match, variableData, digitalFootprint) {
    switch (match.url) {
      case '/portfolio':
        return <GridView columns={["col-md-6","col-md-6"]} components={this.views('portfolio', variableData)} />;
        break;
      case '/recommendations':
        return <GridView columns={["col-md-3","col-md-5","col-md-4"]} showBackButton={true} components={this.views('recommendations', variableData)} />;
        break;
      case '/dashboard':
        return <GridView columns={["col-md-6","col-md-6"]} showBackButton={true} showSecondaryButton={true} components={this.views('dashboard', variableData)} />;
        break;
      default:
        if (match.params && match.params.view) {
          return <GridView columns={["col-md-4","col-md-4","col-md-4"]} showBackButton={true} backTo={'/dashboard'} backButtonText="Back to dashboard" view={match.params.view} components={this.views(match.params.view, variableData)} />;
        } else if (match.params && match.params.report) {
          switch(match.params.report) {
            case 'index':
              return <GridView columns={["col-md-4","col-md-8"]} components={this.views('insights', variableData)} />;
              break;
            case 'price':
              return <GridView columns={["col-md-4","col-md-4","col-md-4"]} showBackButton={true} components={this.views('insightsPrice', variableData)} />;
              break;
            default:
              break;
          }
        } else {
          if (digitalFootprint) {
            return <GridView columns={["col-md-4","col-md-4","col-md-4"]} components={this.views('brandUniverse', variableData)} />;
          } else {
            return <GridView columns={["col-md-4","col-md-4","col-md-4"]} components={this.views('brandHealth', variableData)} />;
          }
        }
        break;
    }
  }

  insightsLauncher() {
    const insightsEnabled = false;
    if (insightsEnabled && process.env.REACT_APP_INSIGHTS_ACTIVE === "true") {
      return <Launcher/>;
    }
  }

  render() {
    const { match, data, user } = this.props;
    const variableData = data.variableData ? this.prepareVariableData(data.variableData) : {};
    const digitalFootprint = this.props.user && this.props.user.client && this.props.user.client.digitalFootprint;

    return (
      <div>
        {this.route(match, variableData, digitalFootprint)}
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    user: state.user,
    data: state.data
  };
}

export default connect(mapStateToProps, { receivedBrandData, didRequestInitialData, initTelescopeData, receivedTelescopeData, setEndDate, setStartDate, setAvailableDates, receivedBrandAwarenessData, receivedAdAwarenessData, receivedBrandConsiderationData })(ViewController);



// WEBPACK FOOTER //
// ./src/components/ViewController.js